export const cleanBase64 = (base64Complete) => {
  const block = base64Complete.split(';');
  const contentType = block[0].split(':')[1];
  const base64 = block[1].split(',')[1];
  return { base64, contentType };
};
